<template>
  <div></div>
</template>
<script>
export default {
  name: 'login',
  data() {
    return {};
  },
  mounted() {
    //https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9d05c795448230b7&redirect_uri=http%3A%2F%2Franfm.wzgo.cn%2Findex&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect
    if (process.env.NODE_ENV === 'production') {
      location.href =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9d05c795448230b7&redirect_uri=' +
        encodeURIComponent('http://ranfm.wzgo.cn/index') +
        '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
    } else {
      console.log('本地模拟登录');
      // this.$store.commit('SET_RAXW_USER', {
      //   score: 7711,
      //   ref_user_code: '1023',
      //   account_id: '62047dfb010ef63b9dfc760c',
      //   invitation_number: 5,
      //   head_img: 'https://img.tmuyun.com/assets/20230705/1688527387503_64a4e21b79f6be61f9bf56ca.png',
      //   nick_name: '葡萄战车raxw版本',
      //   mobile: '18815158532',
      //   ref_user_uid: '12173',
      //   ref_code: 'XUX4D9',
      //   username: '葡萄战车raxw版本'
      // });

      this.$store.commit('SET_OPEN_ID', 'oCPIn6-U3hY8uBS0s5wnEaCJX-7s');
      this.$store.commit('SET_ENV', 'wx');
      this.$router.push('/login');
    }
  }
};
</script>
